import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import type { BriefingResourceDetail, IResourceModel } from '@/shared/model/briefing-widget.model';
import { getHostName } from '@/util/ds-util';
import { map2ResourceItem } from '@/util/mapper-utils';

@Component({
  methods: {
    getHostName,
  },
})
export default class GroupCardV2 extends Vue {
  @Prop(Object) readonly groupData: IResourceModel;
  currentPage = 0;
  size = 7;

  @Emit('view-detail') viewDetail(resource: BriefingResourceDetail) {
    return map2ResourceItem({
      documentType: 'DISCOVERY',
      parentDocDetail: { ...resource, is_group_children: true },
      _id: resource._id,
      is_deleted: resource.is_deleted,
      is_bookmarked: false,
      userProfile: this.groupData.userProfile,
    });
  }

  back() {
    this.currentPage--;
  }

  next() {
    this.currentPage++;
  }
}
